// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutHeader-HeaderGrid_cls1__5-ksl","cls2":"PayoutHeader-HeaderGrid_cls2__xNoTA PayoutHeader-HeaderGrid_cls1__5-ksl","pad":"PayoutHeader-HeaderGrid_pad__imVk2"};